import { useContext } from 'react'
import { ImperialBookingContext } from '../context/ImperialBookingContext'
import useApiRequest from './useApiRequest'

const useResident = () => {
  const { apiGet, apiPost, apiPut } = useApiRequest()
  const {
    resident,
    setResident,
    residentLoaded,
    setResidentLoaded,
    nonResident,

    getCredentials,

    email,
    firstName,
    lastName,
    phone,
    unit,
    hasPadSetUp,
    isPhoneVerified,
    isDisabled,
    hasActivePhoneVerification,
    setHasActivePhoneVerification,

    hasExpiredPhoneVerification,
    setHasExpiredPhoneVerification,

    setFirstName,
    setLastName,
    setEmail,
    setIsDisabled,
    setPhone,
    setUnitNumber,
    setHasPadSetUp,
    setIsPhoneVerified,
  } = useContext(ImperialBookingContext)

  const fetchResident = async () => {
    const { userId } = await getCredentials()
    return apiGet(`residents/${userId}`)
      .then((data) => {
        //console.log('resident', data)
        setResident(data)
        const {
          first_name: firstName,
          last_name: lastName,
          email,
          phone,
          unit,
          has_pad_set_up: hasPadSetUp,
          phone_verified: isPhoneVerified,
          active_verification: hasActivePhoneVerification,
          phone_verification_expires_at: phoneVerificationExpiresAt,
          disabled: isDisabled,
        } = data
        //console.log('firstName', firstName)
        setFirstName(firstName)
        setLastName(lastName)
        setEmail(email)
        setIsDisabled(isDisabled)

        if (phone.length === 10) {
          setPhone(`${phone.substring(0, 3)}-${phone.substring(3, 6)}-${phone.substring(6, 10)}`)
        } else {
          setPhone(phone)
        }
        setUnitNumber(unit)
        setHasPadSetUp(hasPadSetUp)
        setIsPhoneVerified(isPhoneVerified)
        setHasActivePhoneVerification(hasActivePhoneVerification)
        setHasExpiredPhoneVerification(phoneVerificationExpiresAt ? (Math.round((new Date()).getTime() / 1000) > phoneVerificationExpiresAt) : false)
      })
      .catch((err) => {
        console.log(err)
      })
      .finally(() => {
        setResidentLoaded(true)
      })
  }

  const saveResident = async () => {
    const { userId } = await getCredentials()

    const payload = {
      user_id: userId,
      first_name: firstName,
      last_name: lastName,
      email: email,
      phone: phone,
      unit,
      pad_set_up: hasPadSetUp,
    }

    return apiPost(`residents`, payload)
      .then(() => {
        fetchResident()
      })
  }

  const updateResident = async ({ firstName, lastName, phone, unit }) => {
    const { userId } = await getCredentials()

    const payload = {
      first_name: firstName,
      last_name: lastName,
      phone: phone,
      unit,
    }

    return apiPut(`residents/${resident.id}`, payload)
      .then(() => {
        fetchResident()
      })
  }

  const requestPhoneVerification = async () => {
    return apiPost('request_phone_verification')
      .then((result) => {
        console.log(result)
      })
  }

  const verifyPhone = async (code) => {
    const payload = { code }
    return apiPost('verify_phone', payload)
      .then((result) => {
        console.log(result)
        fetchResident()
      })
  }

  return {
    firstName,
    lastName,
    email,
    isDisabled,
    phone,
    unit,
    hasPadSetUp,
    isPhoneVerified,
    nonResident,
    hasActivePhoneVerification,
    hasExpiredPhoneVerification,
    setHasExpiredPhoneVerification,

    resident,
    fetchResident,
    residentLoaded,
    saveResident,
    updateResident,
    requestPhoneVerification,
    verifyPhone,
  }
}

export default useResident
